import { useQuery } from "urql";

import {
  DashboardCustomersByLongestDpdDocument,
  QueryDashboardCustomersByLongestDpdArgs,
} from "../../../graphql/generated.ts";

export const useDashboardCustomersByLongestDpd = (
  variables: QueryDashboardCustomersByLongestDpdArgs
) => {
  return useQuery({
    query: DashboardCustomersByLongestDpdDocument,
    variables,
  });
};
